/** @format */

export const DATE_FORMATS = {
  "DD.MM.YYYY": "DD.MM.YYYY",
  "DD-MM-YYYY": "DD-MM-YYYY",
  "DD/MM/YYYY": "DD/MM/YYYY",
  "DD.MM.YYYY hh:MM": "DD.MM.YYYY hh:MM",
  "DD MMM YY hh:MM": "DD MMM YY hh:MM",
  "MMM DD YYYY hh:MM": "MMM DD YYYY hh:MM",
  "YYYY-MM-DD": "YYYY-MM-DD",
};

export const TICKET_SEVERITY = [
  {
    label: "Minor",
    value: "MINOR",
  },
  {
    label: "Major",
    value: "MAJOR",
  },
];

export const EXTENDED_TECH_SUPPORT_OPTIONS = [
  {
    label: "Yes",
    value: true,
  },
  {
    label: "No",
    value: false,
  },
];

export const TICKET_STAGES = {
  NO_STAGE: "NO_STAGE",
  COMPLAINT_FORM_SUBMITTED: "COMPLAINT_FORM_SUBMITTED",
  COMPLAINT_FORM_UPDATED: "COMPLAINT_FORM_UPDATED",
  UNDER_WARRANTY: "UNDER_WARRANTY",
  OUT_OF_WARRANTY: "OUT_OF_WARRANTY",
  ASSIGN_SE: "ASSIGN_SE",
  REASSIGN_SE: "REASSIGN_SE",
  UPDATE_ACTION_CODE: "UPDATE_ACTION_CODE",
  UPDATE_DEFECT_CODE: "UPDATE_DEFECT_CODE",
  ENTER_ENGINE_DETAILS: "ENTER_ENGINE_DETAILS",
  ENGINE_REPLACEMENT: "ENGINE_REPLACEMENT",
  PARTS_REPLACEMENT: "PARTS_REPLACEMENT",
  ENGINE_REPLACEMENT_REQ_SUBMITTED: "ENGINE_REPLACEMENT_REQ_SUBMITTED",
  PARTS_REPLACEMENT_REQ_SUBMITTED: "PARTS_REPLACEMENT_REQ_SUBMITTED",
  ENGINE_REPLACEMENT_APPROVED: "ENGINE_REPLACEMENT_APPROVED",
  ENGINE_REPLACEMENT_REJECTED: "ENGINE_REPLACEMENT_REJECTED",
  ACTION_CODE_UPDATED: "ACTION_CODE_UPDATED",
  COMMENT: "COMMENT",
  TICKET_UPDATED: "TICKET_UPDATED",
  ATTACHMENT: "ATTACHMENT",
  JIR_CREATED: "JIR_CREATED",
  APPROVER_ASSIGNED: "APPROVER_ASSIGNED",
  FOC_CREATED: "FOC_CREATED",
  FOC_UPDATED: "FOC_UPDATED",
  WAITING_FOR_SE_ACKNOWLEDGEMENT: "WAITING_FOR_SE_ACKNOWLEDGEMENT",
  ADD_INSPECTION_DATE: "ADD_INSPECTION_DATE",
};

export const USER_ROLES = {
  ADMIN: "ADMIN",
  OEM: "OEM",
};
export const USER_LIMITS = {
  ADMIN: "admin",
  APPROVER: "approver",
  FLOAT_ENGINE_MANAGER: "floatEngineManager",
  // QUALITY: "quality",
  SERVICE_ENGINEER: "serviceEngineer",
  QUALITY_CREATOR: "qualityCreator",
  QUALITY_APPROVER: "qualityApprover",
  QUALITY_ADMIN: "qualityAdmin",
};
export const getAvatarColor = (letter) => {
  const colorMap = {
    A: "#ed40a5", // Darker Light Red
    B: "#F06292", // Darker Light Pink
    C: "#BA68C8", // Darker Light Purple
    D: "#9575CD", // Darker Lavender
    E: "#7986CB", // Darker Light Indigo
    F: "#64B5F6", // Darker Light Blue
    G: "#4FC3F7", // Darker Sky Blue
    H: "#26C6DA", // Darker Light Cyan
    I: "#26A69A", // Darker Light Teal
    J: "#81C784", // Darker Light Green
    K: "#AED581", // Darker Pastel Lime
    L: "#DCE775", // Darker Light Yellow
    M: "#FFEE58", // Darker Pastel Yellow
    N: "#FFD54F", // Darker Light Amber
    O: "#FFB74D", // Darker Peach
    P: "#FF7043", // Darker Pastel Orange
    Q: "#c9785b", // Darker Soft Brown
    R: "#135b80", // Darker Very Light Grey
    S: "#17a1e6", // Darker Pastel Blue Grey
    T: "#05ddf7", // Darker Pale Cyan
    U: "#69ad1c", // Darker Pale Green
    V: "#f7a120", // Darker Pale Peach
    W: "#ff0505", // Darker Pale Lavender
    X: "#FFABAB", // Darker Light Coral
    Y: "#da05ff", // Darker Soft Mauve
    Z: "#ff031c", // Darker Soft Pink
  };

  return colorMap[letter?.toUpperCase()] || "#000000"; // Default to black
};

export const COST_ACCESS_EMAILS = [
  "sidhant@bellcorpstudio.com",
  "engineering@bellcorpstudio.com",
  "admin1@gmail.com",
  "service@simpson.co.in",
];
